import { createContext, useContext, useState } from 'react';

const UploadProgressContext = createContext();

export const UploadProgressProvider = ({ children }) => {
    const [progress, setProgress] = useState(0);
    return (
        <UploadProgressContext.Provider value={{ progress, setProgress }}>
            {children}
        </UploadProgressContext.Provider>
    );
};

export const useUploadProgress = () => useContext(UploadProgressContext);